import Vue from 'vue'
import { decode } from 'lib/util'
import select from 'dom-select'
import subscribe from 'klaviyo-subscribe'

Vue.component('newsletter-form', {
  props: [
    'provider',
    'source',
    'listId',
    'mailchimpUrl',
    'klaviyoUrl',
    'klaviyoGroup',
    'errorText',
    'successText',
    'listOptions'
  ],
  data () {
    return {
      callbackFnName: 'newsletterSuccess',
      query: {
        ...(this.provider === 'klaviyo' && { g: this.klaviyoGroup })
      },
      response: false,
      hasError: false
    }
  },
  methods: {
    onInputChange ({name, value}) {
      this.query[name] = value
    },
    submit (e) {
      e.preventDefault()

      const inputField = select('input', this.$el)
      const isValid = this.$children.every(c => c.validate())
      if (!isValid) {
        this.response = ''
        this.hasError = true
        inputField.focus()
        return
      }

      this.hasError = false
      this.response = this.successText
      subscribe(this.listId, this.query['EMAIL']).then(this.klaviyoResponseHandler)
    },
    klaviyoResponseHandler ({ success, errors = [] }) {
      if (success) {
        this.hasError = false
        this.response = this.successText
      } else {
        this.hasError = true
        this.response = errors.join('\n')
      }
    },
    isValidEmail ({ value }) {
      return /\S+@\S+\.\S+/.test(value)
    },
    getListOptions () {
      try {
        return JSON.parse(decode(this.listOptions))
      } catch (error) {
        return []
      }
    },
    getInitialList () {
      return this.getListOptions()[0]['value']
    }
  }
})
